import { HttpErrorResponse } from '@angular/common/http';
import type { ErrorHandler } from '@angular/core';
import { inject, Injectable, Injector } from '@angular/core';
import type { OnyxHttpErrorResponse } from '@onyx/angular';
import { createErrorHandler } from '@sentry/angular';
import { ValidationHelper } from '../helpers/validation.helper';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly injector = inject(Injector);

  private readonly sentryHandler = createErrorHandler();

  public handleError(error: unknown): void {
    if (error instanceof Error) {
      const LAZY_CHUNK_ERROR = 'Failed to fetch dynamically imported module';
      if (error.message.includes(LAZY_CHUNK_ERROR)) {
        this.handleLazyChunkError();
      }
    } else if (error instanceof HttpErrorResponse) {
      if ((error as OnyxHttpErrorResponse).handled) return;

      this.handleHttpResponseError(error);
    } else {
      this.sentryHandler.handleError(error);
    }

    // eslint-disable-next-line no-console
    console.error(error);
  }

  private handleHttpResponseError(response: HttpErrorResponse): void {
    const isAsset = response.url?.startsWith(location.origin);
    if (isAsset) return;

    ValidationHelper.handleUnexpectedResponse(response, this.injector);
  }

  private handleLazyChunkError(): void {
    location.reload();
  }
}
